import { render, staticRenderFns } from "./screen-setting.vue?vue&type=template&id=7201b43e&"
import script from "./screen-setting.vue?vue&type=script&lang=js&"
export * from "./screen-setting.vue?vue&type=script&lang=js&"
import style0 from "./screen-setting.vue?vue&type=style&index=0&id=7201b43e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports